<template>
  <SortingVisualizer />
</template>

<script>
import SortingVisualizer from "./components/SortingVisualizer.vue";

export default {
  name: "App",
  components: {
    SortingVisualizer,
  },
};
</script>

<style></style>
